@if (hasPredictions) {
  <div
    class="checkbox__list__filter__title search-filter-title"
    data-cy="checkbox-list-filter-label"
    >{{ filterCriteria.label }}</div
    >
  }
  @if (hasPredictions) {
    <mat-list class="checkbox__list__filter__list">
      <campus-checkbox-filter
        class="checkbox-filter"
        [criterium]="filterCriteria"
        [maxVisibleItems]="maxVisibleItems"
        [sortBySelection]="sortBySelection"
        (selectionChanged)="onSelectionChange()"
        >
      </campus-checkbox-filter>
    </mat-list>
  }
